module.exports = __webpack_public_path__ + "static/img/3_4_2.8ca29990.jpg";